<template>
  <div class="filter-container">
    <div class="filter-row">
      <div class="filter-category" v-for="item in cate" :key="item.name">
        <div class="category-title">{{item.name}}</div>
        <div class="category-list">
          <div
            class="category-item category-allitem"
            v-if="showall"
            v-bind:class="{active:selectedfilters&&selectedfilters.indexOf(allitemList[item.name])>-1}"
            v-on:click="selectCate(allitemList[item.name])"
          >{{allitemList[item.name].name}}</div>
          <div
            class="category-item"
            v-for="subitem in item.list"
            :key="subitem.name"
            v-bind:class="{active:selectedfilters&&selectedfilters.indexOf(subitem)>-1,'category-item-small':item.list.length>10}"
            v-on:click="selectCate(subitem)"
          >{{subitem.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterTable2",
  model: {
    prop: "selectedfilters"
  },
  data() {
    return {
      allitemList: {}
    };
  },
  props: {
    selectedfilters: Array, //$t('global.选中列表')
    cate: Array, //$t('global.类别列表')
    singleselect: Boolean, //$t('global.是否单选')
    showall: Boolean //$t('global.是否显示全部')
  },
  methods: {
    selectCate(item) {
      if (!this.singleselect) {
        if (this.selectedfilters.indexOf(item) > -1) {
          this.selectedfilters.splice(this.selectedfilters.indexOf(item), 1);
        } else {
          this.selectedfilters.push(item);
        }
      } else {
        if (this.selectedfilters.indexOf(item) == -1) {
          var changed = false;
          for (var i = 0; i < this.selectedfilters.length; i++) {
            if (this.selectedfilters[i].cat == item.cat) {
              this.selectedfilters[i] = item;
              changed = true;
              break;
            }
          }
          if (!changed) {
            this.selectedfilters.push(item);
          }
        } else {
          this.selectedfilters.splice(this.selectedfilters.indexOf(item), 1);
        }
      }
      this.$forceUpdate();
      this.$emit("select-changed");
    }
  },
  created() {
    if (this.showall) {
      this.allitemList = {};
      for (var i = 0; i < this.cate.length; i++) {
        this.allitemList[this.cate[i].name] = {
          name: this.$t("global.全部"),
          value: "",
          cat: this.cate[i].list[0].cat
        };
      }
    }
  }
};
</script>

<style scoped>
.filter-container {
  /* overflow-y: scroll;
  height: 2.6rem; */
}
.filter-row {
  padding: 0.38rem 0;
}
.filter-category {
  margin: 0.28rem 0 0;
  position: relative;
  overflow: hidden;
  zoom: 1;
  display: flex;
  flex-direction: row;
}
.filter-category:first-child {
  margin: 0;
}
.category-title {
  font-size: 14px;
  color: #777;
  border-right: 2px solid #ebebeb;
  float: left;
  box-sizing: border-box;
  width: 80px;
  margin: 0 20px;
  word-break: break-word;
}
.filter-category:last-child .category-title {
  margin-right: 20px;
}
.category-list {
  flex: 1;
  position: relative;
}
.category-item {
  width: 150px;
  margin-bottom: 10px;
  float: left;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.category-item-small {
  margin-bottom: 8px;
}
.category-item-small:hover {
  color: #0060ff;
}
.category-item.active {
  color: #0060ff;
}
.category-item:hover {
  color: #0468ff;
}
.classificationbox .category-title {
  padding-left: 0;
  width: 100px;
  height: 28px;
  font-size: 14px;
  text-align: center;
  border-radius: 14px;
  line-height: 28px;
  background-color: #e8e8e8;
}
.classificationbox .category-item {
  font-size: 12px;
  margin: 6px 20px 6px 0;
  width: 123px;
  cursor: pointer;
  box-sizing: border-box;
}
.classificationbox .category-item:last-child {
  border-right: none;
}
.classificationbox .filter-row {
  padding: 20px 0 0 0;
}
.classificationbox .filter-category {
  margin-top: 15px;
}
.classificationbox .filter-row .filter-category:first-child {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FilterTable.vue